export default "__VITE_ASSET__AOnCY4NP__"